<div class="modal-header">
    <h4 class="title-txt title-txt-lg">
      {{'modals.earn-calculator-modal.title' | translate}}
      <span class="white-space-nowrap">{{'modals.earn-calculator-modal.title-2' | translate}}</span>
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="content">
        <div class="main">
          <div class="block-page mb-0">
            <div class="bg-block-page-primary">
              <div class="container">
                <div class="calculate">
                    <base href="">
                    <!-- The widget scripts are injected in ngAfterContentInit from
                         environment.staticUrl (CD-3557). Angular strips <script>
                         from templates, so tags here never executed anyway. -->
                    <coin-depo-earn-calculator isToken="true" isTokenLanding="true" use-event="true" path-to-coin-icons="https://static.coindepo.com/icons">
                    </coin-depo-earn-calculator>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
</div>
